import React from 'react';
import { useFragment } from 'react-relay';
import { graphql } from 'relay-runtime';
import { SpotlightTarget, SpotlightManager } from '@atlaskit/onboarding';
import { HierarchyToggle as HierarchyToggleBase } from '@atlassian/jira-issue-table-hierarchy-toggle/src/index.tsx';
import { HierarchyToggleOnboarding } from '@atlassian/jira-issue-table-hierarchy/src/ui/hierarchy-onboarding/index.tsx';
import type { hierarchyToggle_issueNavigator_HierarchyToggleItem$key } from '@atlassian/jira-relay/src/__generated__/hierarchyToggle_issueNavigator_HierarchyToggleItem.graphql';

export const HierarchyToggleItem = ({
	viewResult,
	isGroupingSupported,
	onChangeHierarchy,
}: {
	viewResult: hierarchyToggle_issueNavigator_HierarchyToggleItem$key;
	isGroupingSupported?: boolean;
	onChangeHierarchy: (isHierarchyEnabled: boolean) => void;
}) => {
	const viewResultData = useFragment<hierarchyToggle_issueNavigator_HierarchyToggleItem$key>(
		// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
		graphql`
			fragment hierarchyToggle_issueNavigator_HierarchyToggleItem on JiraIssueSearchViewMetadata {
				...HierarchyToggle @arguments(staticViewInput: $staticViewInput)
			}
		`,
		viewResult,
	);

	return (
		<SpotlightManager>
			<SpotlightTarget name="hierarchy-feature-toggle">
				<HierarchyToggleBase
					isGroupingSupported={isGroupingSupported}
					viewResult={viewResultData}
					onChangeHierarchy={onChangeHierarchy}
				/>
			</SpotlightTarget>
			<HierarchyToggleOnboarding />
		</SpotlightManager>
	);
};
